'use strict';

/**
 * Инциализация in-view
 * @module
 */

// ----------------------------------------
// Imports
// ----------------------------------------

import InView from '../_vendors/inview/in-view.js';

// ----------------------------------------
// Public
// ----------------------------------------

(function ($) {
	if ($('.title--big,.title--bigest').length) {
		let title = new InView();
		title.threshold(0.8);
		title('.title--big,.title--bigest').on('enter', el => {
			let $el = $(el);
			$el.addClass('is-anim');
			setTimeout(function () {
				$el.removeClass('has-anim');
				$el.children().children('.lt-anim').removeAttr('style');
			}, 2000);
		});
	}

	let $el = $('.js-fix-buttons');

	if ($el.length) {
		let fix = new InView();
		let wh = $(window).height();
		let hid = 'is-hidden';
		let wh2 = (wh < $(window).width()) ? wh / 2 : wh;
		fix.threshold(0);
		fix.offset({
			top: wh2,
			bottom: wh2
		});
		fix('.buttons-fix-container')
		.on('enter', el => {
			$el.removeClass(hid);
		})
		.on('exit', el => {
			$el.addClass(hid);
		});
	}
})(window.jQuery);



// WEBPACK FOOTER //
// ./src/js/_modules/inview.js